import { ResultsStatus } from '../../models';

/**
 * Dictionary of level and messages according to ConnectionPointTestStatus
 */
export const connectionPointStatusDictionary: { [status: number]: { level: ResultsStatus, message: string } } = {
    200: {
        level: ResultsStatus.Warning,
        message: '_unavailableConnectionPointsCount_ connection point(s) desynchronized'
    },
    250: {
        level: ResultsStatus.Warning,
        message: 'Warning on _unavailableConnectionPointsCount_ connection point(s)'
    },
    400: {
        level: ResultsStatus.Error,
        message: '_unavailableConnectionPointsCount_ connection point(s) unavailable'
    },
    550: {
        level: ResultsStatus.Warning,
        message: 'PI SDK will be deprecated in the future. Consider using PI AF instead'
    }
};
